/* tslint:disable:max-classes-per-file */
import React, { useContext } from 'react';
import { TimeRangeSelect } from '../../forms';
import { Card, CardSegment, TimeRangeNavigator } from '../../ui';
import ChartCard from '../ChartCard';

// TODO I do not think we should be digging into lib for types
// TODO: there must be a more elequent way of importing
import { Query } from 'react-apollo';
import { NotebookContext } from '../../../context/NotebookContext';
import { Measurement } from '../../../lib/helpers/measurement';
import {
  MeasurementsQuery,
  MeasurementsQueryVariables
} from '../../../queries/__generated__/MeasurementsQuery';
import { measurementsQuery } from '../../../queries/measurements';
import ErrorScreen from '../../utils/ErrorScreen';
import EmptyState from '../../../pages/notebook/subject/id/EmptyState';

interface IChartListProps {
  subject: {
    id: string;
    name: string;
    slug: string;
    trackers: {
      id: string;
      name: string;
      slug: string;
      type: TrackerType;
    }[];
  };
}

const SubjectChartList: React.FC<IChartListProps> = ({ subject }) => {
  const { notebook } = useContext(NotebookContext);

  return (
    <>
      {subject.trackers.length > 0 &&
        subject.trackers.map(tracker => (
          <Query<MeasurementsQuery, MeasurementsQueryVariables>
            query={measurementsQuery}
            key={`${subject.id}-${tracker.id}`}
            variables={{
              input: {
                notebookId: notebook.id,
                subjectIds: [subject.id],
                trackerIds: [tracker.id]
              }
            }}
          >
            {({ data, loading, error }) => {
              if (loading) {
                return <div />;
              }
              if (error) {
                return <ErrorScreen error={error.message} />;
              }

              const measurements = data!.measurements.map(m => new Measurement(m));

              return (
                <ChartCard
                  key={`${tracker.id}`}
                  measurements={measurements}
                  chartType={tracker.type}
                  chartTitle={tracker.name}
                />
              );
            }}
          </Query>
        ))}
    </>
  );
};

export default SubjectChartList;
